export enum ScimAdminCqrsActions {
    ConfigGet = 'ScimConfigGetQuery',
    ConfigUpdate = 'ScimConfigUpdateCommand',
    SecretRegenerate = 'ScimSecretRegenerateCommand',
}
